import { render, staticRenderFns } from "./PreviewTotal.vue?vue&type=template&id=4f394e2e&"
import script from "./PreviewTotal.vue?vue&type=script&lang=js&"
export * from "./PreviewTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports